module.exports = __webpack_public_path__ + "static/media/icon_bath.9b6d6727.svg";